import React from 'react';
import {
  IonRow,
  IonCol,
  IonButton,
  IonGrid,
  IonTextarea,
  IonPage,
  IonIcon
} from '@ionic/react';
import { Rating } from 'react-simple-star-rating';
import './Feedback.scss';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { setScreenName } from '../../../utils/Analytics';
import { submitFeedback } from '../../../actions/Menu/action';
import * as Constants from '../../../utils/constants';
import { makeSubmitFeedback } from '../../../selectors/Menu/selector';
import { getUserMasterData, getLoading, getNetworkStatus, getMoreContent } from '../../../selectors/selector';

import useInjectSaga from '../../../utils/injectSaga';
import useInjectReducer from '../../../utils/injectReducer';
import reducer from '../../../reducers/Menu/reducer';
import saga from '../../../saga/Menu/saga';
import { Feedback } from '../../../models/home/Menu.model';
import { showNetworkAlert } from '../../../actions/App/action';
import { CustomModalWeb } from '../userProfile/CustomModalWeb';
import i18n from '../../../../i18n';
import { FormatText } from '../Support/FormatTextComponent/formatText';

const key = 'Menu';

export class FeedbackComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      rating: 0,
      feedback: '',
      isShowModal: false,
      isShowPopup: false
    };
    this.onStarClick = this.onStarClick.bind(this);
  }

  onStarClick(nextValue: any) {
    this.setState({ rating: nextValue });
  }

  handleOkClick = () => {
    const { history } = this.props;
    this.setState({ isShowModal: false, rating: 0, feedback: '' });
    history && history.push('/app/home');
  };

  getVersion = (browserDetails: any, val: any) => browserDetails.split(val)[1].split(' ')[0];

  onSubmitFeedbackClick = async () => {
    const browserDetails = navigator.userAgent;
    const browser: any = Constants.BROWSER_DATA.find(item => browserDetails.indexOf(item.value) !== -1);
    const browserName = browser.name || '';
    const browserVersion = this.getVersion(browserDetails, browser.value) || '';
    const model: Feedback = new Feedback();
    model.appVersion = '';
    model.upn = this.props.userDetails &&
    this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.upn;
    model.deviceUUID = '';
    model.carrierId = this.props.userDetails &&
    this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.carrierId;
    model.carrierName = this.props.userDetails &&
    this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.companyName;
    model.rating = this.state.rating;
    model.feedback = this.state.feedback;
    model.firstName = this.props.userDetails &&
    this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.firstName;
    model.lastName = this.props.userDetails &&
    this.props.userDetails.memberDetailsResponse &&  this.props.userDetails.memberDetailsResponse.member && this.props.userDetails.memberDetailsResponse.member.lastName;
    model.devicePlatform = 'Web';
    model.deviceManufacturer = browserName;
    model.deviceOSVersion = '';
    model.deviceModel = browserVersion;
    this.props.submitFeedback(model.getRequestPayload(), this.feedBackCallback);
  };

  feedBackCallback = () => {
    if (
      this.props &&
      this.props.submitFeedbackCall &&
      this.props.submitFeedbackCall.data &&
      this.props.submitFeedbackCall.data.feedback === true &&
      this.state.isShowPopup
    ) {
      this.setState({ isShowModal: false, rating: 0 });
    } else {
      this.setState({ isShowModal: true });
    }
  };

  feedbackHandler = (event: any) => {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.name === 'feedback') {
      this.setState({ feedback: event.target.value });
    }
  };
  feedbackModalProps = {
    title: Constants.FEEDBACK_HEADER,
    message_content: Constants.FEEDBACK_MESSAGE,
    size: "small_height",
    buttons: [
      {
        title: i18n.t("Ok_TEXT"),
        type: "primary-cta-btn-web",
        onClick: () => this.handleOkClick()
      }
    ]
  };
  render() {
    const { rating } = this.state;
    const menuItemDetails =  this.props?.menuData?.data?.getUserHelpContent?.menuEntries
    const selectedSubMenu = this.props?.menuData?.data?.getUserHelpContent?.menuItems?.filter((details: any) => details?.group[0]?.menuItem === "Contact Options")[0];
    const feedBackDetails = menuItemDetails?.filter((data: any) => 
       data.uid == selectedSubMenu?.group[0]?.uid
    )[0];
    setScreenName('screen_feedback_page');
    return (
      <IonPage className="desktop-page">
        <h1 className="heading-search">{Constants.PAGE_TITLES.FEEDBACK}</h1>
        <div className="feedback-container">
          <IonGrid>
            {feedBackDetails?.sections?.map((data: any) => {
              return data?.title?.includes("Feedback") ? (
                <>
                  <div className="sub-heading">
                    <FormatText text={data?.title || Constants.FEEDBACK_SUBHEAD} dataType={"richText"} />
                  </div>
                  <div className="feedback-title">
                    <FormatText
                      text={data?.richTextDescription || Constants.FEEDBACK_CONTENT}
                      dataType={"richText"}
                    />{" "}
                  </div>
                </>
              ) : null;
            })}
          </IonGrid>
          <div className="feedbackDiv" data-test="Feedback-div">
          <CustomModalWeb isModalOpen={this.state.isShowModal} {...this.feedbackModalProps} />
            <IonGrid className="feedback-grid">
              <p className="feedback-p notLikely">{Constants.NOT_LIKELY}</p>
              <p className="feedback-p likely">{Constants.VERY_LIKELY}</p>
              <IonRow className="feedback-row">
                <IonCol className="feedback-column">
                  {/* <Rating
                    name="rate1"
                    starCount={5}
                    value={rating}
                    onStarClick={this.onStarClick}
                    starColor="#FF6114"
                    className="starRating"
                    renderStarIcon={(index: any, value: any) => (
                      <IonIcon
                        className="starRatingIcon"
                        src={
                          index <= value
                            ? 'assets/icon/feedback-star-filled.svg'
                            : 'assets/icon/feedback-star.svg'
                        }
                      />
                    )}
                  /> */}
                  <Rating
                    fillColor="#f85f14"
                    className="starRating"
                    initialValue={rating}
                    onClick={this.onStarClick}
                  />

                </IonCol>
              </IonRow>
            </IonGrid>
            {rating === 0 ? null : (
              <>
                <IonGrid>
                  {rating <= 3 && rating >= 1 ? (
                    <div className="head-text">{Constants.IMPROVING_SERVICE}</div>
                  ) : (
                    <div className="head-text">{Constants.MORE_FEEDBACK}</div>
                  )}
                  <IonGrid className="text-div">
                    <IonTextarea
                      maxlength={2000}
                      placeholder={Constants.FEEDBACK_COMMENTS}
                      onIonChange={e => this.feedbackHandler(e)}
                      name="feedback"
                      value={this.state.feedback}
                    />
                  </IonGrid>
                  <IonRow class="ion-text-right">
                    <IonCol>{this.state.feedback.length}/2000</IonCol>
                  </IonRow>
                </IonGrid>
              </>
            )}
            <IonRow class="ion-text-right">
              <IonCol>
                <IonButton
                  data-test="submit-button"
                  data-kind="primary"
                  type="submit"
                  disabled={rating === 0}
                  class="primary-cta-btn-web"
                  onClick={() => this.onSubmitFeedbackClick()}>
                  {Constants.SUBMIT}
                </IonButton>
              </IonCol>
            </IonRow>
          </div>
        </div>
      </IonPage>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  submitFeedbackCall: makeSubmitFeedback(),
  userDetails: getUserMasterData(),
  isLoading: getLoading(),
  isNetworkAvailable: getNetworkStatus(),
  menuData: getMoreContent()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  submitFeedback: (data: any, callback: Function) => dispatch(submitFeedback(data, callback)),
  showAlert: () => dispatch(showNetworkAlert())
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });

export default compose<any>(withConnect, withReducer, withSaga)(React.memo(FeedbackComponent));
